export default __webpack_public_path__ + "static/media/map2.aab16252.png";